// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7240":"2442b057","7660":"2442b057"}[chunkId] + ".chunk.css";
};